let imageNumber = [[7,8,10],[11,12,13],[14,4,5],[6,1,2],[3]]

function Gallery(){
    return (<div class="container">
        <div class="section">
            <h2>Our Gallery</h2>
            <div class="gallery">
                {imageNumber.map(row => {
                  return <div class="gallery-row">
                    {row.map(number => {
                      return <img src={`./images/pic-${number}.jpeg`} alt={`Image ${number}`}/>;
                    })}
                  </div>
                })}
            </div>
        </div>
    </div>)
}

export default Gallery;